export enum PhoneNumbCheckStatus {
    SUCCESS = 'success',
    LOADING = 'loading',
    WARNING = 'warning',
    ERROR = 'error',
}

export enum LoginRoles{
    RETAILER = 'retailer',
    RETAILERADMIN = 'retaileradmin',
    KITCHENRETAILER = 'kitchen',
    KITCHENRETAILERADMIN = 'kitchenretaileradmin',
}

export enum ProductTypes {
    KITCHEN = 'kitchen',
    GROCERY = 'grocery',
}

export enum OrderTypes {
    INSTANT = 'Instant',
    GROCERY = 'grocery',
    BULKORDER = 'bulkorder'
}
